<template>
    <div>
        <div
            class  = "import-header "
            :id    = "id"
            :style = "'max-width: ' + (size.x-100) + 'px;'"
            ref="header"
        >
            <div
                class="v-flex primary white--text pt-1 pb-1"
                :style="'width:' + scrollWidth + 'px; ' + ((rightPadding === '0') ? 'border-top-left-radius: 6px;' : '')"
            >
                <div style="width: 30px" v-if="showUnits">

                </div>
                <div class="import-unit-col" v-if="showUnits">
                    Anlagen
                </div>

                <div
                    v-for  = "(column,colindex) in columns"
                    class  = "import-column"
                    :key   = "id + colindex"
                    :style = "width(column)"
                >
                    <a @click = "onSort(column, colindex)" class="white--text">
                        <span>{{ $t('importer.header.' + column.property) }}</span>
                        <span><v-icon color="white">{{ sortIcon (column.sort) }}</v-icon></span>
                    </a>
                </div>
            </div>
        </div>

        <div
            class   = "import-content"
            :style  = "'max-width: ' + (size.x-100+rightPadding) + 'px; height: ' + (size.y-150) + 'px;'"
            @scroll = "onScroll"
        >
            <div
                :style="'width:' + scrollWidth + 'px'"
                class="pb-1"
            >
                <div v-for="(row, rowindex) in filteredRows" :key="'row-' + rowindex" >
                    <div class="v-flex" style="border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: lightgrey">
                        <div v-if="showUnits" style="width: 30px; padding-left: 3px; padding-top: 0; margin-top: 8px; margin-bottom: 8px;" class="lm-border">
                            <v-icon size="22" color="primary">{{ row.id ? "mdi-file-refresh-outline" : "mdi-file-plus-outline" }}</v-icon>
                        </div>

                        <div class="import-unit-col pt-2 pl-0 pr-1 ml-1" v-if="showUnits">
                            <a @click="onUnits(row)">
                                <div
                                    class  = "tool-button v-flex"
                                    :class = "unitBorder (row)"
                                >
                                    <div style="margin-top: -2px">
                                        <c-toolbar-button
                                            :size = "22"
                                            :color = "unitIconColor (row)"
                                            icon   = "mdi-elevator-passenger"
                                            :tooltip = "row.error ? $t('importer.error.' + row.error) : 'OK'"
                                        />
                                    </div>
                                    <v-spacer />
                                    <div :class="unitIconColor (row) + '--text'">
                                        {{ row.units.length }}
                                    </div>
                                </div>
                            </a>
                        </div>




                        <div
                            v-for  = "(column, columnIndex) in row.values"
                            class  = "import-column"
                            :key   = "'row-' + rowindex + '-Y' + columnIndex"
                            :style = "valueWidth(columnIndex)"
                        >
                            <div class="import-value" v-if = "column.value !== '-'">
                                {{ targetFormat ? toTargetFormat(column, columnIndex) : (column.value ? column.value : '---') }}
                            </div>

                            <div class="import-value error--text" v-if = "column.value === '-'">
                                Löschen
                            </div>

                            <div
                                v-if="!column.error && !column.warning && !columns[columnIndex].info"
                                class="import-value-ok success--text"
                            >
                                <span v-if="column.value">OK</span>
                            </div>
                            <div
                                v-if="column.error"
                                class="import-value-error error--text"
                            >
                                {{ $t("importer.error." + column.error) }}
                            </div>
                            <div
                                v-if="column.warning"
                                class="import-value-error warning--text"
                            >
                                {{ $t("importer.error." + column.warning) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ImporterMixin from "@/modules/msd/importer/mixins/ImporterMixin";
import Core from "@/modules/core/service/Core";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";

export default {
    name: "PImportContent",
    components: {
        CToolbarButton
    },

    props: {
        id: {

        },

        rows: {

        },

        columns: {

        },

        size: {

        },

        showUnits: {

        },

        filter: {

        },

        unitColumns: {

        },

        scrollWidth: {

        },

        rightPadding: {

        },

        targetFormat: {

        }
    },

    mixins: [
        ImporterMixin
    ],

    data: () => ({
        filteredRows: []
    }),

    computed: {
    },

    mounted() {
        this.onFilter();
    },

    watch: {
        filter: {
            deep: true,
            handler: function () {
                this.onFilter();
            }
        },

        rows() {
            this.onFilter();
        }
    },

    methods: {
        onScroll (event) {
            const header = document.querySelector("#" + this.id);
            header.scrollLeft = event.target.scrollLeft;
        },

        onUnits (row) {
            this.$emit("units", {
                units  : row.units,
                columns: this.unitColumns
            });
        },

        onSort (column, index) {
            const sort = column.sort;
            this.columns.forEach(column => column.sort = null);

            switch (sort) {
                case "UP"  :
                    column.sort = "DOWN";
                    break;
                case "DOWN":
                    column.sort = "UP";
                    break;
                default:
                    column.sort = "UP";
            }

            this.rows.sort((l, r) => {
                let lValue = l.values[index].value;
                let rValue = r.values[index].value;

                if (!lValue) lValue = "";
                if (!rValue) rValue = "";

                if (column.sort === "UP") {
                    return lValue.localeCompare(rValue);
                }

                return rValue.localeCompare(lValue);

            });
        },

        onFilter () {
            this.filteredRows = [];
            this.rows.forEach(row => {
                let unitsOk = true;
                if (this.showUnits) {
                    unitsOk = !row.unitsWithError && !row.unitsWithWarning;
                }

                if (!this.filter.errors) {
                    this.filteredRows.push(row);
                } else {
                    const hasErrors = !!row.values.find(v => v.error || v.warning ) || !unitsOk;
                    if (hasErrors) {
                        this.filteredRows.push(row);
                    }
                }
            })
        },

        sortIcon (dir) {
            switch (dir) {
                case "UP"  : return "mdi-arrow-up";
                case "DOWN": return "mdi-arrow-down";
            }

            return null;
        },

        unitBorder (row) {
            if (row.unitsWithError) {
                return "error-border"
            }

            if (row["unitsWithWarning"]) {
                return "warning-border"
            }

            return "lm-border"
        },

        unitIconColor (row) {
            if (row["unitsWithError"] || row.error) {
                return "error"
            }

            if (row["unitsWithWarning"]) {
                return "warning"
            }

            return "primary"
        },

        toTargetFormat (column, index) {
            if (!column.value) {
                return "---";
            }

            switch (this.columns[index].type) {
                case "Date":
                    return Core.format.date.display(column.target);
                case "Money":
                    return Core.format.money(column.target);
                case "Boolean":
                    return column.value;
            }

            return column.value;
        }
    }
}
</script>

<style scoped>

.import-header::-webkit-scrollbar {
    display: none;
}

div::-webkit-scrollbar {
    width: 8px !important;
    height: 8px !important;
}

.import-header, .import-content{
    overflow-y: auto;
    overflow-x: auto;
    border-top-right-radius: 6px;
}

.import-column {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 8px;
    padding-right: 8px;
    font-size: 15px;
}

.import-value {
    height: 26px;
    font-size: 15px;
    padding-top: 4px;
}

.import-value-ok, .import-value-error {
    font-size: 10px;
    padding-bottom: 4px;
    height: 19px;
}

.import-unit-col {
    width: 75px;
    font-size: 15px;
    padding-left: 8px;
}

.tool-button {
    padding: 3px 6px 2px 4px;
}

</style>